import {
  ControlBlocksService,
  DevicesService,
  ElectronicClockService,
  ElectronicClocks_DisplayBrightnessModel,
  ElectronicClocks_ScreenDelayModel,
  GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse,
  SetDeviceSourceModel,
  StateModel,
} from "../api";
import {ElectronicClockParams} from "../components/menu/ExternalDevices/components/ElectronicClock/ElectronicClock.model";
import {
  mapElectronicClockDataResponse,
  mapElectronicClockParamsResponse,
} from "../shared/Helpers.utils";

export const ElectronicClockApi = {

  // Получение параметров
  getElectronicClockParams: async (id: string): Promise<ElectronicClockParams> => {
    const response = await ElectronicClockService.getApiElectronicClockParams(id);
    return mapElectronicClockParamsResponse(response as Record<string, unknown>);
  },

  // Получение workdays
  getWorkdays: async (id: string): Promise<string> => {
    const response = await ElectronicClockService.getApiElectronicClockWorkdays(id);
    return String(response.workdays ?? "");
  },

  // Обновление состояния
  updateState: async (id: string, enabled: boolean): Promise<boolean> => {
    const payload: StateModel = {enabled};
    await ElectronicClockService.postApiElectronicClockDisplayState(id, payload);
    return true;
  },

  // Обновление яркости
  updateBrightness: async (id: string, value: number): Promise<boolean> => {
    const payload: ElectronicClocks_DisplayBrightnessModel = {value};
    await ElectronicClockService.postApiElectronicClockDisplayBrightness(id, payload);
    return true;
  },

  // Обновление задержки отображения
  updateScreenDelay: async (id: string, value: Record<string, string | number>): Promise<boolean> => {
    const payload: ElectronicClocks_ScreenDelayModel = {
      time: Number(value.time ?? 0),
      date: Number(value.date ?? 0),
      temperatureFromSensor: Number(value.temperatureFromSensor ?? 0),
      temperature: Number(value.temperature ?? 0),
      pressure: Number(value.pressure ?? 0),
      humidity: Number(value.humidity ?? 0),
    };

    await ElectronicClockService.postApiElectronicClockScreenDelay(id, payload);
    return true;
  },

  //Получение данных эл часов
  getElectronicClockData: async (id: string) => {
    const response = await DevicesService.getApiDevices(id);
    return mapElectronicClockDataResponse(response as Record<string, unknown>);
  },

  // Вывод серийного номера
  updateSerialState: async (id: string, enabled: boolean) => {
    const payload: StateModel = {enabled};
    await ElectronicClockService.postApiElectronicClockSerialState(id, payload);
    return true;
  },

  //Получение источника метео-данных
  getMeteoSource: async (id: string): Promise<GetMeteoSourceBroadcastDevice_GetMeteoSourceBroadcastDeviceResponse> => {
    return ControlBlocksService.getApiControlBlocksMeteoSource(id);
  },

  //Обновление источника метео-данных
  updateMeteoSource: async (id: string, deviceId: string | null): Promise<boolean> => {
    const payload: SetDeviceSourceModel = {deviceId};
    await ControlBlocksService.postApiControlBlocksMeteoSource(id, payload);
    return true;
  },
}
